import { IPartCategory } from "./Part";
import { DefaultResponseWithData } from "./system";

export interface IPartLookupResponse extends DefaultResponseWithData<IPartDataResponse> { }

export const PartProBlackList: string[] = ["chrysler", "daeweoo", "daihatsu", "dodge", "isuzu", "jeep", "lancia", "mitsubishi", "opel", "ssangyong", "subaru"];

export interface IPartDataResponse {
  requestId: string;
  vin: string;
  requestedParts: IPartResponse[];
  failedUcids: string[];
  make: string;
  model: string;
  manufacturerPaintColourCode: string;
  vehicleEquipment: IVehicleEquipment[];
}

export interface IVehicleEquipment {
  family: string;
  manufacturerCodes: string;
  source: string;
  subFamily: string;
  value: string;
  description: string;
  familyDescription: string;
  subFamilyDescription: string;
}

export interface IPartResponse {
  partType: string;
  partNumber: string;
  ucid: string;
  partCategory: IPartCategory;
  priceInformation: IPartPriceStatistics;
}

export interface IPartPriceStatistics {
  partNumber: string;
  minPrice: number;
  maxPrice: number;
  avgPrice: number;
  manufacturerPrice: number;
  confidence: string;
}


export interface IMarketDataLookupRequest {
  make: string | undefined;
  model: string | undefined;
  year: number | null | undefined;
}

export interface IMarketDataLookupResponse {
  categories: ICategoryStats[];
  totalValue: number;
}

export interface ICategoryStats {
  categoryId: string;
  categoryName: string;
  minPrice: number;
  maxPrice: number;
  avgPrice: number;
  quantity: number;
}

export interface IIntelligencePricingResponse extends DefaultResponseWithData<ISerpApiSearchResult[]> { }

export interface IBulkIntelligencePricingResult {
  partId: string;
  results: ISerpApiSearchResult[];
}

export interface IBulkIntelligencePricingResponse extends DefaultResponseWithData<IBulkIntelligencePricingResult[]> { }

/** Which Wilma Intelligence search found a listing, tried in this order until one returns prices. */
export type IntelligenceLookupType = "OePartNumber" | "PartNumber" | "Vehicle";

export interface ISerpApiSearchResult {
  searchTerm: string;
  title: string;
  link: string;
  condition: string;
  priceRaw: string;
  priceExtracted: number | null;
  thumbnail: string;
  /** @deprecated The sold-listings search was switched off; every result is an active listing. */
  isSold?: boolean;
  /** @deprecated Always empty now that only active listings are returned. */
  soldDate?: string | null;
  /**
   * Set when the AI result filter judged the listing not to be the part searched for (wrong side,
   * wrong part, wrong vehicle). Still shown so staff can check, but left out of every price figure.
   */
  excludedReason?: string | null;
  /** Set on Wilma Intelligence part lookups only; null on Initial Price Estimate results. */
  matchedOn?: IntelligenceLookupType | null;
}